import { Modal } from '@breuni-ui/bdk-modal';
import { safeDefine } from '@breuni-ui/safe-define';
import { VSP_OPEN_EVENT, VspOpenEventDetail } from './vsp-event.js';

export { VSP_OPEN_EVENT };
export type { VspOpenEventDetail };

const VSP_SSI_URL = '/reco/kombi-modul/ssi/vsp';

export class VspModal extends Modal {
  private readonly onOpen = (event: Event) => this.handleOpen(event as CustomEvent<VspOpenEventDetail>);

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(VSP_OPEN_EVENT, this.onOpen);
  }

  disconnectedCallback() {
    document.removeEventListener(VSP_OPEN_EVENT, this.onOpen);
    super.disconnectedCallback();
  }

  private async handleOpen(event: CustomEvent<VspOpenEventDetail>) {
    const { syan, colorId } = event.detail;

    const placeholderLoader = this.querySelector('reco-vsp-loader[data-ents-vsp-placeholder]');
    if (placeholderLoader) {
      placeholderLoader.setAttribute('syan', String(syan));
      if (colorId) {
        placeholderLoader.setAttribute('color-id', colorId);
      } else {
        placeholderLoader.removeAttribute('color-id');
      }
      this.show();
      return;
    }

    if (colorId && (await this.loadVsp(colorId))) {
      this.show();
    }
  }

  private async loadVsp(colorId: string): Promise<boolean> {
    const container = this.querySelector<HTMLElement>('[data-ents-vsp-ssi-container]');
    if (!container) {
      return false;
    }
    container.innerHTML = '';
    const url = `${VSP_SSI_URL}?colorId=${encodeURIComponent(colorId)}&pageType=wishlist`;
    let response: Response;
    try {
      response = await fetch(url);
    } catch {
      return false;
    }
    if (!response.ok) {
      return false;
    }
    container.innerHTML = await response.text();
    loadModule(container.querySelector('script')?.getAttribute('src'));
    return true;
  }
}

function loadModule(src: string | null | undefined) {
  if (!src || document.head.querySelector(`script[src="${src}"]`)) {
    return;
  }
  document.head.appendChild(Object.assign(document.createElement('script'), { src, type: 'module' }));
}

safeDefine('ents-vsp-modal', VspModal);
